import {
    FilterableMailBoxUrlSlugs,
    FilterableMessageCentreUrlSlugs,
    MessageCentreUrlSlugs,
    PrivateMessageCentreUrlSlugs
} from "@twigsby/client-data";
import {GenericFilterEntryType} from "@twigsby/client-data/lib/Types/GenericTypes";
import {Location} from "react-router-dom";
import {BuildUrlFilterFromParams} from "./UrlSlugsAndFilters";

export interface MessageCentreUrlParamsType {
    messageId?: string;
    startDate?: string;
    endDate?: string;
    searchTerm?: string;
    read?: string;
    archived?: string;
    hasAttachment?: string;
}

type BuildMessageCentreUrlFilterFromParamsType = {
    // @ts-ignore
    [name: keyof MessageCentreUrlSlugs]: GenericFilterEntryType;
};

const MessageCentreUrlMapping = (props: MessageCentreUrlParamsType, location: Location): PrivateMessageCentreUrlSlugs => {
    let newParams: PrivateMessageCentreUrlSlugs = {};

    return newParams;
}

const MessageCentreFilterUrlMapping = (props: MessageCentreUrlParamsType, location: Location): FilterableMessageCentreUrlSlugs => {
    let newParams: FilterableMailBoxUrlSlugs = {};

    newParams = {
        ...newParams,
        ...BuildMessageCentreUrlFilterFromParams(props, location,'searchTerm'),
        ...BuildMessageCentreUrlFilterFromParams(props, location,'startDate'),
        ...BuildMessageCentreUrlFilterFromParams(props, location,'endDate'),
        ...BuildMessageCentreUrlFilterFromParams(props, location,'archived'),
        ...BuildMessageCentreUrlFilterFromParams(props, location,'read'),
        ...BuildMessageCentreUrlFilterFromParams(props, location,'hasAttachment'),
    }

    return newParams;
}

const BuildMessageCentreUrlFilterFromParams = (props: MessageCentreUrlParamsType, location: Location, name: keyof MessageCentreUrlSlugs, data?: any, isArray?: boolean, overrideValue?: any): BuildMessageCentreUrlFilterFromParamsType => {
    return BuildUrlFilterFromParams(props, location, name, data, isArray, overrideValue);
}

export {
    MessageCentreUrlMapping,
    MessageCentreFilterUrlMapping
}
